import React from "react";
import { useNavigate } from "react-router-dom";
import "../../style/common.scss";
import "./privacyPolicy.scss";

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      window.close();
    }
  };

  return (
  <div className="privacy-page-bg">
    <div className="privacy-policy-page">

      <div className="privacy-hero">
        <div className="privacy-hero-title">
          <h1>Privacy Policy</h1>
          <button className="privacy-close-btn" onClick={handleClose} aria-label="Close" title="Close">&#x2715;</button>
        </div>
        <p>Application: <strong>Dictionary</strong></p>
      </div>

      <section>
        <h2>1. Data Administrator</h2>
        <p>
          The administrator of the personal data of users of the "Dictionary" application is Adam Borkowski.
          <br />
          Email: <a href="mailto:adamb2310@gmail.com">adamb2310@gmail.com</a>
        </p>
      </section>

      <section>
        <h2>2. Scope of Data Processed</h2>
        <ul>
          <li>Email address</li>
          <li>Username</li>
          <li>
            Profile picture
            <ul>
              <li>Link from Google login</li>
              <li>Image uploaded by user</li>
            </ul>
          </li>
        </ul>
      </section>

      <section>
        <h2>3. Purpose</h2>
        <ul>
          <li>User account management</li>
          <li>Learning and saving words</li>
          <li>Authentication</li>
        </ul>
      </section>

      <section>
        <h2>4. Legal Basis</h2>
        <p>Processing is necessary for providing the service (GDPR art. 6(1)(b)).</p>
      </section>

      <section>
        <h2>5. Google Login</h2>
        <p>
          Basic profile data is received after user consent in Google authentication system.
        </p>
      </section>

      <section>
        <h2>6. Storage Time</h2>
        <p>Until account deletion.</p>
      </section>

      <section>
        <h2>7. Data Recipients</h2>
        <p>Data is stored on secure hosting infrastructure.</p>
      </section>

      <section>
        <h2>8. User Rights</h2>
        <ul>
          <li>Access</li>
          <li>Rectification</li>
          <li>Deletion</li>
          <li>Restriction</li>
        </ul>
      </section>

      <section>
        <h2>9. Security</h2>
        <p>Technical and organisational protection measures are applied.</p>
      </section>

      <section>
        <h2>10. Changes</h2>
        <p>Policy may be updated. Current version is always published.</p>
      </section>

    </div>
  </div>
  );
};

export default PrivacyPolicy;